import React, { Component } from 'react';
// import AnalyticsManager from '../../functions/analytics';
import RecurveBaseComponent from '../RecurveBaseComponent';
import RecurveUtility from '../../functions/utility';
import parseItem from '../../functions/ParseItem';
import ItemFunctions from '../../functions/ItemFunctions';
import priceCalculations from '../../functions/priceCalculations';
import ModifierFunctions from '../../functions/ModifierFunctions';
import AddOnItemFunctions from '../../functions/AddOnItemFunctions';

const ItemContext = React.createContext({});

class Item extends Component {
    constructor(props) {
        super(props);
        // noinspection JSDuplicatedDeclaration
        this.state = {
            loading: true,
            hasPopupError: false,
            hasServerError: false,
            quantity: 1,
            isValid: true,
            comment: '',
            showServiceTypeSelector: !window.session.service_type_id, //coerce to bool -- changed to simplify RR.
            serviceTypeName: window.session.service_type_name,
            itemAdded: false,
            // serviceTypeName: window.session.service_type_name,
            functions: {
                selectMainItem: ItemFunctions.selectMainItem.bind(this),
                calculateSubtotal: priceCalculations.calculateSubtotal.bind(this),
                processSubmitAttempt: ItemFunctions.processSubmitAttempt.bind(this),
                determineExcludedModifiers: ModifierFunctions.determineExcludedModifiers.bind(this),
                // determineIncludedModifiers: ModifierFunctions.determineIncludedModifiers.bind(this),
                // determineExcludedModifiers: ModifierFunctions.determineExcludedModifiers.bind(this),
                determineIncludedModifiers: ModifierFunctions.determineIncludedModifiers.bind(this),
                reAddIncludedItem: ModifierFunctions.reAddIncludedItem.bind(this),
                excludeIncludedItem: ModifierFunctions.excludeIncludedItem.bind(this),
                setFirstHalfOnly: ModifierFunctions.setFirstHalfOnly.bind(this),
                setSecondHalfOnly: ModifierFunctions.setSecondHalfOnly.bind(this),
                setWholePortion: ModifierFunctions.setWholePortion.bind(this),
                setExtra: ModifierFunctions.setExtra.bind(this),
                setLight: ModifierFunctions.setLight.bind(this),
                setNormalSize: ModifierFunctions.setNormalSize.bind(this),
                removeOptionalModifier: ModifierFunctions.removeOptionalModifier.bind(this),
                handleModifierQuantityChange: ModifierFunctions.handleModifierQuantityChange.bind(this),
                increaseModifierQuantity: ModifierFunctions.increaseModifierQuantity.bind(this),
                decreaseModifierQuantity: ModifierFunctions.decreaseModifierQuantity.bind(this),
                handleChangeToItemComment: ItemFunctions.handleChangeToItemComment.bind(this),
                increaseItemQuantity: ItemFunctions.increaseItemQuantity.bind(this),
                decreaseItemQuantity: ItemFunctions.decreaseItemQuantity.bind(this),
                numberOfSelections: ItemFunctions.numberOfSelections.bind(this),
                markAsValid: ItemFunctions.markAsValid.bind(this),
                markAsInvalid: ItemFunctions.markAsInvalid.bind(this),
                closeServiceTypeSelector: ItemFunctions.closeServiceTypeSelector.bind(this),
                showServiceTypes: ItemFunctions.showServiceTypes.bind(this),
                hideServiceTypes: ItemFunctions.hideServiceTypes.bind(this),
                updateServiceType: ItemFunctions.updateServiceType.bind(this),
                chooseAddOnItem: AddOnItemFunctions.chooseAddOnItem.bind(this),
                decreaseAddOnQuantity: AddOnItemFunctions.decreaseAddOnQuantity.bind(this),
                increaseAddOnQuantity: AddOnItemFunctions.increaseAddOnQuantity.bind(this),
                removeAddOnItem: AddOnItemFunctions.removeAddOnItem.bind(this)
            }
        };
        this.utility = {...RecurveUtility};
        this.parseItem = parseItem.bind(this);
        this.calculatePriceForAddons = priceCalculations.calculatePriceForAddons.bind(this);
        this.calculatePriceForMatrixPricing = priceCalculations.calculatePriceForMatrixPricing.bind(this);
        this.calculatePriceForPriceLevels = priceCalculations.calculatePriceForPriceLevels.bind(this);
        this.calculateSubtotalWithoutAddons = priceCalculations.calculateSubtotalWithoutAddons.bind(this);
        this.getModifierPriceForPriceLevel = priceCalculations.getModifierPriceForPriceLevel.bind(this);
        this.getIncludedModifierPriceForPriceLevel = priceCalculations.getIncludedModifierPriceForPriceLevel.bind(this);
        this.getModifierPriceForChoice = priceCalculations.getModifierPriceForChoice.bind(this);
        this.getTotalMatrixWeightForChosenIncluded = priceCalculations.getTotalMatrixWeightForChosenIncluded.bind(this);
        this.getTotalMatrixWeightForChosenModifier = priceCalculations.getTotalMatrixWeightForChosenModifier.bind(this);
        this.submitCustomization = ItemFunctions.submitCustomization.bind(this);
    }

    componentDidMount() {
        let itemURL = this.props.apiUrl ? `${this.props.apiUrl}` : `${document.location}`;
        itemURL = itemURL.replace('?' , '');
        itemURL = itemURL.replace('#' , '');
        fetch(`${itemURL}/api`).then( (response) => {
            if(response.status > 300 && response.status < 400) document.location.reload(); //Follow redirects
            if(response.ok) {
            response.json().then( (resJ) => {
                if (resJ.item.item_group.items.length < 1) {
                    this.setState({
                        no_items: true
                    })
                    setTimeout(() => {window.location = `${window.relativeURI()}/menu`}, 3000);
                } else {
                    this.parseItem(resJ.item, resJ.category);
                }
                });
            }else {
                if(response.status === 422) {
                    response.json().then( (resJ) => {
                        this.setState({error: resJ, loading: false});
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    });
                }else {
                    response.json().then( (resJ) => {
                        this.setState({error: resJ, loading: false, hasServerError: true});
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    });
                }
            }
        }, (rejection) => {
            console.log(rejection);
        });
    }

    render() {
        return (
            <ItemContext.Provider value={this.state}>
                {!this.state.no_items && <RecurveBaseComponent loading={this.state.loading} error={this.state.error} hasServerError={this.state.hasServerError} hasPopupError={this.state.hasPopupError} content={this.props.content} />}
                {
                    this.state.no_items &&
                    <div className={"container"}>
                        <div className={"mt-4"}>
                            <b><i>This item has no available options. You are being redirected to the menu in 3 seconds...</i></b>
                        </div>
                    </div>
                }
            </ItemContext.Provider>
        )
    }
}
export { Item, ItemContext };
